import { Component, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';

interface sesion {
  num: number;
  titulo: string;
  duracion: number;
  tipo: string;
  completado: number;
}

interface curso {
  id: string,
  titulo: string,
  foto: string,
  instructorNombre: string,
  instructorFoto: string,
  precioFinal: number,
  cantVentas: number,
  publicado: boolean,
}

interface instructor {
  id: string,
  nombre: string,
  resumen: string,
  cantCursos: number,
  foto: string,
  publicado: boolean,
}

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})

export class InicioComponent implements OnInit {

  token = JSON.parse(localStorage.getItem('token'))

  // spinner
  loaded = 1;

  // media predeterminada
  backColor = 'black';
  back1: string = "assets/images/background/back1.jpg"
  logoP21: string = "assets/images/logos/logo-predictiva-blanco-sm.png"
  laptop: string = "assets/images/design/laptop-foto-predyc.jpg"
  capacitacionEmpresas: string = "assets/images/design/capacitacion-empresas.jpg"
  bannerPredyc: string = "assets/images/design/predyc-banner.jpg"
  experta: string = "assets/images/design/experta.jpg"
  experta2: string = "assets/images/design/experta2.png"
  certificado: string = "assets/images/design/certificado.jpg"

  // info demo sesion
  sesion: sesion[] = [
    { num: 1, titulo: "Relación de un análisis RAM con la vida del activo", duracion: 7, tipo: "video", completado: 1 },
    { num: 2, titulo: "Información requerida para realizar un análisis RAM", duracion: 13, tipo: "video", completado: 1 },
    { num: 3, titulo: "Etapas para efectuar un análisis RAM", duracion: 22, tipo: "lectura", completado: 1 },
    { num: 4, titulo: "Construcción del modelo en el análisis RAM", duracion: 6, tipo: "video", completado: 0 },
    { num: 5, titulo: "Bases de Datos", duracion: 9, tipo: "lectura", completado: 0 },
  ];

  // Auxiliares para el front
  mostrarInfo;

  // Variables   
  cursosDestacados: any[] = [];
  instructoresDestacados: any[] = [];

  // Información de banner
  bannerFlag = false
  bannerMensaje = ""

  constructor(
    private afs: AngularFirestore,
    public router: Router,
    private seo: SeoService,
  ) { }

  ngOnInit(): void {
    this.cargarBanner()
    this.cargarCursoDestacados();
    this.cargarInstructoresDestacados();
    this.seo.generateTags({
      title: "Predyc - Capacitación Industrial",
      image: "assets/images/logos/logo.svg",
      description: "Entrenamiento en línea para el sector industrial. Obtén tu certificado y especializate en el área de tu preferencia"
    })
  }

  async cargarBanner(){
    const doc = await this.afs.collection("global").doc("fechas").ref.get()
    const data = doc.data()
    this.bannerFlag = data["bannerFlag"]
    this.bannerMensaje = data["bannerMensaje"]
  }

  cargarCursoDestacados() {
    this.afs.doc("global/indiceCursos").get().subscribe(snap => {
      const cursos = snap.data();
      let arr = []
      Object.keys(cursos).map(function (key) {
        arr.push(cursos[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        arreglo.push(arr[index])
      }
      arreglo.sort((a, b) => b.cantVentas - a.cantVentas);
      var limit = 0;
      for (let index = 0; index < arreglo.length; index++) {
        if (limit < 10) {
          if (arreglo[index].publicado == true) {
            const obj = arreglo[index]
            const curso: curso = {
              id: obj.id,
              titulo: obj.titulo,
              foto: obj.foto,
              instructorNombre: obj.instructorNombre,
              instructorFoto: obj.instructorFoto,
              precioFinal: obj.precioFinal,
              cantVentas: obj.cantVentas,
              publicado: obj.publicado,
            }
            this.cursosDestacados.push(arreglo[index])
            limit += 1;
          }
        }
      }
    })
  }

  cargarInstructoresDestacados() {
    this.afs.doc("global/indiceInstructores").get().subscribe(snap => {
      const instructores = snap.data();
      let arr = []
      Object.keys(instructores).map(function (key) {
        arr.push(instructores[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        arreglo.push(arr[index])
      }
      arreglo.sort((a, b) => b.cantVentas - a.cantVentas);
      var limit = 0;
      for (let index = 0; index < arreglo.length; index++) {
        if (limit < 10) {
          if (arreglo[index].publicado == true) {
            const obj = arreglo[index]
            const instructor: instructor = {
              id: obj.id,
              nombre: obj.nombre,
              resumen: obj.resumen,
              cantCursos: obj.cantCursos,
              foto: obj.foto,
              publicado: obj.publicado,
            }
            this.instructoresDestacados.push(arreglo[index])
            limit += 1;
          }
        }
      }
    })
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.backColor = 'white';   
    } else {
      this.backColor = `black`;
    }
  }
}
